import React from 'react';
import { useTranslation } from 'react-i18next';
import type { User } from '../../types';

interface StatusBadgeProps {
  user: User;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ user }) => {
  const { t } = useTranslation();

  const getStatusLabel = () => {
    if (!user.isActive) return t('admin.userManagement.filters.deleted', 'Supprimé');
    if (user.isFrozen) return t('admin.userManagement.filters.frozen', 'Gelé');
    return t('admin.userManagement.filters.active', 'Actif');
  };

  const getStatusClass = () => {
    if (!user.isActive) return 'status-badge--deleted';
    if (user.isFrozen) return 'status-badge--frozen';
    return 'status-badge--active';
  };

  return (
    <span className={`status-badge ${getStatusClass()}`}>
      {getStatusLabel()}
    </span>
  );
};